module.exports = __webpack_public_path__ + "img/cliente.f7a2ac41.svg";